import { TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HeadCell } from '../../../models/TableProps';
import TableCell from '@mui/material/TableCell';
import { BasicHeadCell } from '../../../models/BasicTable/BasicTableProps';

export const BasicTableHead = <T,>(props: TableHeadProps<T>) => {
    const { headContent, translateNs, translatePrefix } = props;
    const { t } = useTranslation(translateNs, {
        keyPrefix: translatePrefix,
    });

    return (
        <TableHead sx={{ overflow: 'hidden' }}>
            <TableRow>
                {headContent.map((headCell, key) => (
                    <TableCell key={key}>
                        <Typography sx={{ whiteSpace: 'nowrap' }}>
                            {headCell.label.length != 0
                                ? t(headCell.label)
                                : ''}
                        </Typography>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

interface TableHeadProps<T> {
    headContent: BasicHeadCell<T>[];
    translateNs: string;
    translatePrefix: string;
}
